export class MarcaModel {
  nombre:string = ""
}

export class CategoriaMarcaModel {
  _id:any = "";
  idDB:any = "";
  nombre:string = "";
  marcas:MarcaModel[] = [];


}
